//angular imports
import { Signal } from "@angular/core";

//local imports
import { IListItem, ListItem, Messenger } from "@app/shared";
import { AbstractRoomNavModel, SelectRoomMessage } from "@app/catalog-common";
import { RoomModel } from "@app/catalog";

export class RoomsNavModel 
  extends AbstractRoomNavModel<RoomModel> {
    
 constructor(
    messenger: Messenger,
    items: Signal<RoomModel[]>
  ) {
    super(messenger, items);
  }

  public select(item: IListItem): void {
    const navItem = item as ListItem<RoomModel>;
    this.messenger.send(new SelectRoomMessage(navItem.value));
  }
}